require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
var _require = require('../internal/constants'),
  MAX_LENGTH = _require.MAX_LENGTH;
var _require2 = require('../internal/re'),
  re = _require2.re,
  t = _require2.t;
var SemVer = require('../classes/semver');
var parseOptions = require('../internal/parse-options');
var parse = function parse(version, options) {
  options = parseOptions(options);
  if (version instanceof SemVer) {
    return version;
  }
  if (typeof version !== 'string') {
    return null;
  }
  if (version.length > MAX_LENGTH) {
    return null;
  }
  var r = options.loose ? re[t.LOOSE] : re[t.FULL];
  if (!r.test(version)) {
    return null;
  }
  try {
    return new SemVer(version, options);
  } catch (er) {
    return null;
  }
};
module.exports = parse;